import { render } from "./PointsLog.vue?vue&type=template&id=7fb9e386&scoped=true&ts=true"
import script from "./PointsLog.vue?vue&type=script&lang=ts"
export * from "./PointsLog.vue?vue&type=script&lang=ts"

import "./PointsLog.vue?vue&type=style&index=0&id=7fb9e386&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb9e386"]])

export default __exports__